import { InjectionToken } from '@angular/core';

/**
 * A token to indicate whether to skip authentication for maps API requests – this is useful for when running maps within an iframe where
 * the host app will have already authenticated maps.
 */
export const MAPS_SKIP_AUTHENTICATION = new InjectionToken<boolean>('mapsSkipAuthentication');
